import { useTranslation } from 'react-i18next';
import { CheckCircle2, Clock, Loader2 } from 'lucide-react';
import type { BrowseIntegration } from '../types';

interface BrowseIntegrationCardProps {
  integration: BrowseIntegration;
  isImporting?: boolean;
}

export const BrowseIntegrationCard = ({
  integration,
  isImporting,
}: BrowseIntegrationCardProps) => {
  const { t } = useTranslation('goals');

  return (
    <div
      onClick={integration.comingSoon ? undefined : integration.onClick}
      className={`flex h-36 flex-col rounded-xl border bg-card p-5 shadow-sm transition-all ${
        integration.comingSoon
          ? 'cursor-default opacity-80'
          : 'cursor-pointer hover:-translate-y-0.5 hover:shadow-md'
      }`}
    >
      <div className="flex items-start justify-between">
        {integration.logo}
        {integration.isInstalled ? (
          <span className="inline-flex items-center gap-1 text-xs font-medium text-green-600">
            <CheckCircle2 className="h-4 w-4" />
            {t('integrationsDialog.installed')}
          </span>
        ) : integration.comingSoon ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground">
            <Clock className="h-3 w-3" />
            {t('integrationsDialog.comingSoon')}
          </span>
        ) : integration.id === 'msproject' && isImporting ? (
          <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
        ) : null}
      </div>
      <div className="mt-auto">
        <h4 className="text-sm font-semibold">
          {t(integration.nameKey as never)}
        </h4>
        <p className="mt-0.5 text-xs text-muted-foreground">
          {t(integration.descriptionKey as never)}
        </p>
      </div>
    </div>
  );
};
